<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Nazwa"
                                      :error="errors[addLanguageSuffix('name')]"
                                      required>
                            <el-input v-model="form[addLanguageSuffix('name')]"/>
                        </el-form-item>
                        <el-form-item label="Opis"
                                      :error="errors[addLanguageSuffix('description')]">
                            <wyswig-input v-model="form[addLanguageSuffix('description')]"/>
                        </el-form-item>
                        <el-form-item label="Opis po rozwinięciu"
                                      :error="errors[addLanguageSuffix('details')]">
                            <wyswig-input v-model="form[addLanguageSuffix('details')]"/>
                        </el-form-item>
                        <el-form-item label="Kolor tła"
                                      :error="errors['bg_color']">
                            <el-color-picker v-model="form.bg_color"/>
                        </el-form-item>
                        <el-form-item label="Kolor tekstu"
                                      :error="errors['text_color']">
                            <el-color-picker v-model="form.text_color"/>
                        </el-form-item>
                    </div>
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">Bilety dostępne w</span>
                        </div>
                        <div v-for="period, i in form.periods" class="ticket-in-periods">
                            <div class="inline-form-group">
                                <el-form-item label="Okres sprzedaży"
                                              :error="errors.periods && errors.periods[i]['period_id']">
                                    <el-select v-model="period.period_id" placeholder="Wybierz okres">
                                        <el-option v-for="option in periods"
                                                   :key="option.id"
                                                   :label="option.name_pl"
                                                   :value="option.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="ID w sklepie alter"
                                              :error="errors.periods && errors.periods[i]['external_id']">
                                    <el-input v-model="period.external_id"/>
                                </el-form-item>
                            </div>
                            <div class="inline-form-group">
                                <el-form-item label="Cena"
                                              :error="errors.periods && errors.periods[i]['price']">
                                    <el-input v-model="period.price" type="number"/>
                                </el-form-item>
                                <el-form-item label="Limit jednorazowo"
                                              :error="errors.periods && errors.periods[i]['limit']">
                                    <el-input v-model="period.limit" type="number"/>
                                </el-form-item>
                            </div>
                            <div class="inline-form-group">
                                <el-form-item label="Kolejność (rosnąco)"
                                              :error="errors.periods && errors.periods[i]['order']">
                                    <el-input type="number" v-model="period.order"/>
                                </el-form-item>
                                <el-form-item label="Wyprzedany"
                                              class="sold-out-input"
                                              :error="errors.periods && errors.periods[i]['sold_out']">
                                    <el-switch v-model="period.sold_out"/>
                                </el-form-item>
                            </div>
                            <el-button @click.stop="removeItemFromFormset(form.periods, period)"
                                       class="remove-button"
                                       size="mini"
                                       icon="el-icon-close"
                                       type="danger"
                                       title="Usuń">
                            </el-button>
                        </div>
                        <el-button type="primary"
                                   @click="addPeriod">
                            Dodaj
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {Ticket, Period} from '@/api/';

    export default {
        data () {
            return {
                loading: false,
                redirectRoute: {name: 'Tickets List'},
                form: {
                    periods: []
                },
                errors: {},
                service: Ticket,
                periods: []
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            addPeriod () {
                if (this.form.periods === undefined) this.form.periods = []
                this.form.periods.push({})
            },
            fetchData () {
                if (this.$route.params.id) {
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                    })
                }
                Period.fetch().then(response => {
                    this.periods = response.data
                })
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const service = id ? this.service.update(id, this.form) : this.service.save(this.form)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .ticket-in-periods {
        position: relative;
        padding: 42px 10px 20px 10px;
        margin-bottom: 10px;
        border: 1px solid #e2e2e2;
    }

    .remove-button {
        position: absolute;
        top: 5px;
        right: 10px;
    }

</style>



// WEBPACK FOOTER //
// TicketForm.vue?1b153bff